import { BANK_RECEIPT_RETURN_TRANSACTION_REQUEST, GET_BANK_RECEIPT_RETURN_TRANSACTIONS, BANK_RECEIPT_RETURN_TRANSACTION_REQUEST_FAILURE,
  GET_ACCOUNT_ID_WISE_CONSIGNEE_BANK_RECEIPT_RETURN_TRANSACTIONS, GET_BANK_NAME_BANK_RECEIPT_RETURN_TRANSACTIONS
} from '../types';

const initialState = {
  bankReceiptReturnTransactions: [],
  accountIdWiseConsigneeBankReceiptReturnTransactions: [],
  bankNamesBankReceiptReturnTransactions: [],
  loading: false,
  error: null,
};

const bankReceiptReturnTransactionReducer = (state = initialState, action) => {
  switch (action.type) {
    case BANK_RECEIPT_RETURN_TRANSACTION_REQUEST: {
      return {
        ...state,
        loading: true,
        error: null
      }
    }
    case GET_BANK_RECEIPT_RETURN_TRANSACTIONS: {
      return {
        ...state,
        bankReceiptReturnTransactions: [...action.payload],
        loading: false,
        error: null
      }
    }
    case GET_ACCOUNT_ID_WISE_CONSIGNEE_BANK_RECEIPT_RETURN_TRANSACTIONS: {
      const { data } = action.payload || {};
      return {
        ...state,
        accountIdWiseConsigneeBankReceiptReturnTransactions: [...data],
        loading: false,
        error: null
      }
    }
    case GET_BANK_NAME_BANK_RECEIPT_RETURN_TRANSACTIONS: {
      const { data } = action.payload || {};
      return {
        ...state,
        bankNamesBankReceiptReturnTransactions: [...data],
        loading: false,
        error: null
      }
    }
    case BANK_RECEIPT_RETURN_TRANSACTION_REQUEST_FAILURE: {
      return {
        ...state,
        loading: false,
        error: action.error
      }
    }
    default:
      return state;
  }
};

export default bankReceiptReturnTransactionReducer;